<app-grid-container class="single-plan-sale">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column>
          <app-progression-steps />
          <h1 class="single-plan-sale__title">
            {{ "SINGLE_PLAN_SALE_PAGE_TITLE" | translate }}
          </h1>

          <p class="single-plan-sale__subtitle">
            Your guarantee gives you repairs for manufacturing faults for
            {{ warrantyInMonths() }}
            months. By adding extra protection to your appliance registration,
            you may avoid potentially expensive repair bills.
          </p>

          <div class="single-plan-sale__tp-provided-by-container">
            <div class="single-plan-sale__trustpilot">
              <app-trustbox />
            </div>
            <p class="single-plan-sale__provided-by">
              {{ "SINGLE_PLAN_SALE_PAGE_PROVIDED_BY" | translate }}
              <img
                [src]="`assets/dg.svg`"
                alt="DNG Logo"
                class="single-plan-sale__provided-by-logo"
              />
            </p>
          </div>

          @if (hasFreeMonths()) {
            <div class="single-plan-sale__2mf-promotional-banner mb-4">
              <app-icon
                [name]="'gift'"
                [size]="'md'"
                aria-hidden="true"
                class="single-plan-sale__2mf-promotional-banner__icon"
              />
              <h5 class="single-plan-sale__2mf-promotional-banner__title">
                {{ "SINGLE_PLAN_SALE_PAGE_2MF_PROMO_BANNER" | translate }}
              </h5>
            </div>
          }
          <app-single-plan-table class="single-plan-sale__table" />

          <div class="single-plan-sale__inclusion-panel">
            <h4 class="single-plan-sale__inclusion-panel-title">
              {{ "SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_TITLE" | translate }}
            </h4>
            <div class="single-plan-sale__inclusion-panel-container">
              <section>
                <app-icon [family]="'solid'" [name]="'circle-check'" />
                <p>
                  {{
                    "SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_ACCESS" | translate
                  }}
                </p>
              </section>
              <section>
                <app-icon [family]="'solid'" [name]="'circle-check'" />
                <p>
                  {{
                    "SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_REPAIRS" | translate
                  }}
                </p>
              </section>
              <section>
                <app-icon [family]="'solid'" [name]="'circle-check'" />
                <p>
                  {{
                    "SINGLE_PLAN_SALE_PAGE_INCLUSION_PANEL_SUPPORT" | translate
                  }}
                </p>
              </section>
            </div>
          </div>

          <div class="single-plan-sale__exclusion-panel">
            <h4 class="single-plan-sale__exclusion-panel-title">
              {{ "SINGLE_PLAN_SALE_PAGE_EXCLUSION_PANEL_TITLE" | translate }}
            </h4>
            <div class="single-plan-sale__exclusion-panel-container">
              @for (exclusion of exclusions(); track exclusion) {
                <section>
                  <app-icon [family]="'light'" [name]="'circle-xmark'" />
                  <p>{{ exclusion }}</p>
                </section>
              }
            </div>
            <app-terms-and-conditions-panel
              [noPadding]="true"
              [toggleIcon]="false"
              [transparent]="true"
              class="single-plan-sale__exclusion-panel-terms-and-conditions"
            />
          </div>

          <section class="single-plan-sale-footer">
            @if (hasPromo()) {
              <div class="single-plan-sale-footer__promo-details">
                <app-single-plan-promo-price
                  [titlePriceVariant]="TitlePriceVariant.Heading2"
                />
                <p class="single-plan-sale-footer__cancel-anytime my-2">
                  {{
                    "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME_ALT"
                      | translate
                  }}
                </p>
                <p class="single-plan-sale-footer__cancel-anytime my-2">
                  {{
                    "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME"
                      | translate
                  }}
                </p>
                @if (applianceInGuarantee()) {
                  <p class="single-plan-sale-footer__disclaimer">
                    {{
                      "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER"
                        | translate
                    }}
                  </p>
                }
              </div>
            } @else {
              <p class="single-plan-sale-footer__title-price">
                @if (isOneOffPayment()) {
                  {{
                    "SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE_ONE_OFF"
                      | translate
                        : {
                            price:
                              selectedQuotePaymentOption.fee | currencyFormat,
                          }
                  }}
                } @else {
                  {{
                    "SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE"
                      | translate
                        : {
                            price:
                              selectedQuotePaymentOption.subsequentPayment
                              | currencyFormat,
                          }
                  }}
                }
              </p>
              @if (!isOneOffPayment()) {
                <p class="single-plan-sale-footer__subtitle">
                  {{ "SINGLE_PLAN_SALE_PAGE_FOOTER_SUBTITLE" | translate }}
                </p>
              }
            }
            <div class="single-plan-sale-footer__buttons">
              <app-grid-row>
                <app-grid-column [md]="6">
                  <app-button
                    (click)="registerOnlyClicked()"
                    [fill]="true"
                    [variant]="'neutral-alternative'"
                  >
                    {{ "SINGLE_PLAN_SALE_PAGE_CTA_REGISTER_ONLY" | translate }}
                  </app-button>
                </app-grid-column>
                <app-grid-column [md]="6">
                  <app-button
                    (click)="purchasePlanClicked()"
                    [fill]="true"
                    [variant]="'success'"
                    class="single-plan-sale-footer__button--purchase-plan"
                  >
                    {{ "SINGLE_PLAN_SALE_PAGE_CTA_PURCHASE_PLAN" | translate }}
                  </app-button>
                </app-grid-column>
              </app-grid-row>
            </div>

            <p class="single-plan-sale__provided-by">
              {{ "SINGLE_PLAN_SALE_PAGE_PROVIDED_BY" | translate }}
              <img
                [src]="`assets/dg.svg`"
                alt="DNG Logo"
                class="single-plan-sale__provided-by-logo"
              />
            </p>

            <div class="single-plan-sale__footer-trustpilot">
              <app-trustbox />
            </div>
          </section>
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
